type Params = Record<string, unknown>

export function formatServiceAreaUpsertRule(params: Params): string {
  const sourceName = params.sourceName ?? '—'
  const serviceAreaName = params.serviceAreaName ?? '—'
  const isActive = params.isActive
  const activeLabel =
    isActive === true ? 'Active' : isActive === false ? 'Inactive' : '—'
  return `${sourceName} — ${serviceAreaName}, isActive: ${activeLabel}`
}
